<template>
  <div class="blog-post-container">
    <div v-if="loading" class="loading">Loading post...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else-if="post" class="blog-post">
      <h2>{{ post.title }}</h2>
      <p class="post-meta">
        <span>{{ formatDate(post.publish_date || post.created_at) }}</span>
        <span v-if="post.views" class="views">• {{ post.views }} views</span>
      </p>
      <div v-if="post.tags && post.tags.length > 0" class="tags">
        <span v-for="tag in post.tags" :key="tag" class="tag">{{ tag }}</span>
      </div>
      <div v-html="post.content_html" class="post-content"></div>
    </div>
    <div v-else class="not-found">Post not found</div>
  </div>
</template>

<script>
import { useBlog } from '@/services/blog';

export default {
  name: 'BlogPost',
  data() {
    return {
      post: null,
      loading: true,
      error: null
    };
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    async fetchPost() {
      const slug = this.$route.params.id;
      try {
        this.loading = true;
        const { getPublicPost } = useBlog();
        this.post = await getPublicPost(slug);
      } catch (error) {
        console.error('Error fetching post:', error);
        this.error = 'Failed to load blog post.';
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.fetchPost();
  },
  watch: {
    '$route.params.id': {
      handler: 'fetchPost',
      immediate: false
    }
  }
};
</script>

<style scoped>
.blog-post {
  font-family: 'Montserrat', sans-serif; /* Use Google Fonts */
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.blog-post h2 {
  margin-bottom: 1rem;
  text-align: center;
}

.blog-post p {
  margin-bottom: 1.5rem;
}

.inline-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1rem 0;
}

.loading, .error, .not-found {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.error, .not-found {
  color: #dc2626;
}

.post-meta {
  text-align: center;
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.views {
  margin-left: 0.5rem;
}

.tags {
  text-align: center;
  margin-bottom: 2rem;
}

.tag {
  display: inline-block;
  background: #f0f0f0;
  padding: 0.25rem 0.75rem;
  margin: 0.25rem;
  border-radius: 20px;
  font-size: 0.85rem;
  color: #555;
}

.post-content {
  line-height: 1.8;
  color: #333;
}

/* Style for markdown content */
.post-content h1,
.post-content h2,
.post-content h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.post-content p {
  margin-bottom: 1rem;
}

.post-content pre {
  background: #f4f4f4;
  padding: 1rem;
  border-radius: 4px;
  overflow-x: auto;
}

.post-content code {
  background: #f4f4f4;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
}

.post-content pre code {
  background: none;
  padding: 0;
}

.post-content blockquote {
  border-left: 4px solid #007BFF;
  padding-left: 1rem;
  margin-left: 0;
  color: #666;
  font-style: italic;
}

.post-content img {
  max-width: 100%;
  height: auto;
  margin: 1rem 0;
}

.post-content ul,
.post-content ol {
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.post-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.post-content th,
.post-content td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: left;
}

.post-content th {
  background: #f4f4f4;
  font-weight: bold;
}
</style>